import service from "@/utils/request";
export function getVipBulletinApi(params) {
    return service({
        url: "/vip/bulletin/getList",
        method: "get",
        params,
    });
}
